import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './registerServiceWorker';


window.addEventListener('beforeinstallprompt', (e) => {

    // Prevent Chrome 67 and earlier from automatically showing the prompt
    // console.log("beforeinstallprompt - Blocked prompt");
    // alert("beforeinstallprompt - Blocked prompt");
    e.preventDefault();

    // Stash the event so it can be triggered later.
    //e.prompt();
    window.addToHomeScreenEvent = e;

    //the little install banner at the bottom cannot be hidden
    //https://developers.google.com/web/updates/2018/06/a2hs-updates
    /*
    Shown regardless of if preventDefault() was called on the beforeinstallprompt event.
     */
});
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

serviceWorker.register();
